import { utils } from '@neo-one/utils';
import { Types } from './Types';
export var StructuredStorageType;
(function (StructuredStorageType) {
    StructuredStorageType["ArrayStorage"] = "ArrayStorage";
    StructuredStorageType["MapStorage"] = "MapStorage";
    StructuredStorageType["SetStorage"] = "SetStorage";
})(StructuredStorageType || (StructuredStorageType = {}));
export const STRUCTURED_STORAGE_TYPES = [
    ...new Set(Object.values(StructuredStorageType)),
];
export const getTypeFromStructuredStorageType = (structuredStorageType) => {
    switch (structuredStorageType) {
        case StructuredStorageType.ArrayStorage:
            return Types.ArrayStorage;
        case StructuredStorageType.SetStorage:
            return Types.SetStorage;
        case StructuredStorageType.MapStorage:
            return Types.MapStorage;
        default:
            utils.assertNever(structuredStorageType);
            throw new Error('For TS');
    }
};

//# sourceMappingURL=StructuredStorageType.js.map
